import { createContext, useContext } from "react";
import type { ComponentType, ReactNode } from "react";

export type FullscreenSlotProps = {
  active: boolean;
  children: ReactNode;
  ariaLabel?: string;
  testId?: string;
};

export const FullscreenSlotContext =
  createContext<ComponentType<FullscreenSlotProps> | null>(null);

export const FullscreenSlot = (props: FullscreenSlotProps) => {
  const Slot = useContext(FullscreenSlotContext);
  if (!Slot) {
    throw new Error("FullscreenSlot requires a host fullscreen provider");
  }
  return <Slot {...props} />;
};
